import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  YandexSingleChatConfig,
  Widget,
  buttonUIFactory,
  yandexUnreadCounterFactory,
} from '@yandex-int/messenger.widget';
import '@yandex-int/messenger.widget/lib/ui/supportbutton.css';

const { REACT_APP_YA_SERVICE_ID, REACT_APP_YA_CHATTERBOX_GUID } = process.env;

let widget = null;

const initChatterbox = (context) => {
  if (widget) {
    return;
  }

  if (!REACT_APP_YA_SERVICE_ID || !REACT_APP_YA_CHATTERBOX_GUID) {
    return;
  }

  const unreadCounterPlugin = yandexUnreadCounterFactory();
  const ui = buttonUIFactory({ unreadCounterPlugin });

  widget = new Widget(
    new YandexSingleChatConfig({
      serviceId: Number(REACT_APP_YA_SERVICE_ID),
      unreadCounterOtherGuid: REACT_APP_YA_CHATTERBOX_GUID,
      authType: 'own',
      authToken: null,
      unreadWithCountChats: true,
      iframeOpenData: {
        guid: REACT_APP_YA_CHATTERBOX_GUID,
        context,
      },
      flags: {
        hideClose: '0',
        disableChatHeader: '0',
        disableChatList: '0',
      },
    })
  );

  widget.handlers.getEnv.addListener((request) => {
    request.response(context);
  });

  widget.addPlugin(unreadCounterPlugin);
  widget.setUI(ui);
  widget.init();
  ui.mount();
};

const initAuthorizedChatterbox = async (user) => {
  if (!user.id || user.isDealersFetch || !user.roles.length || !user.dealers.length) {
    return;
  }

  const role = (user.roles || []).find((r) => r.id === user.role)?.name || '';
  const dealer = (user.dealers || []).find((d) => d.id === user.dealer)?.name || '';
  const user_roles = (user.roles || []).map((r) => r.name).join(', ');

  initChatterbox({
    user_id: `${user.id}`,
    user_email: `${user.email}`,
    display_name: `${user.lastname} ${user.firstname} ${user.middlename}`,
    page_url: window.location.href,
    client_name: dealer,
    role,
    user_roles,
  });
};

const destroyChatterbox = () => {
  if (widget) {
    widget.destroy();
    widget = null;
  }
};

export const Chatterbox = ({ authorized = false }) => {
  const user = useSelector((store) => store.user);

  useEffect(() => {
    if (!authorized) {
      initChatterbox({});
    }
    return () => destroyChatterbox();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (authorized) {
      initAuthorizedChatterbox(user);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return <React.Fragment />;
};
